import styled from 'styled-components'

import { SpinnerProps } from './types'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ffffff;
  z-index: 999;
`

const Dot = styled.div<SpinnerProps>`
  position: absolute;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: ${p => p.color};
  opacity: 0.6;
  animation: bounce 2s infinite cubic-bezier(0.455, 0.03, 0.515, 0.955);

  :nth-child(2) {
    animation-delay: -1s;
  }

  @keyframes bounce {
    0%,
    100% {
      transform: scale(0);
    }
    45%,
    55% {
      transform: scale(1);
    }
  }
`

export { Wrapper, Dot }
